module.exports = __webpack_public_path__ + "img/ce96767ffbc10d121862ea2c30ba80cf.png";